import { render } from "./CreateFrequence.vue?vue&type=template&id=c3e60da4"
import script from "./CreateFrequence.vue?vue&type=script&lang=js"
export * from "./CreateFrequence.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__